import { contentPlaceholders } from "../generated/contentPlaceholders";

export const contentPlaceHolderTypes: {
  [k: string]: {
    [k: string]: {
      [k: string]: string;
    };
  };
} = contentPlaceholders;
export type PlaceHolderTypes = keyof typeof contentPlaceholders;

// proposalProduct tokens that cannot resolve for worksheet lines (no plant products,
// production relations or measurements are ever attached to them).
export const worksheetOnlyDeadPlaceholders = [
  "job_measurement",
  "job_duration",
  "measurement_method",
  "measurement_type",
  "application_rate",
  "application_rate_inches",
  "material_amount",
  "material_amount_tons",
  "cost_per_area",
  "equipment_needed",
  "labour_needed",
  "additional_costs",
  "transfer_trucks",
  "plant_name",
  "plant_product_name",
];
